import React from "react";
import { Badge } from "./tailwind/badge";
import { getFilterIcon, getFilterLabel } from "./filters/filterDisplayUtils.js";

/**
 * Component that displays segment filters as badges in a tooltip
 * Reuses the same filter display logic as ChipsContactFilter
 */
export function SegmentFiltersTooltip({
  segmentFilters,
  children,
  placement = "top",
}) {
  // If no filters, just return the children without tooltip
  if (!segmentFilters || segmentFilters.length === 0) {
    return children;
  }

  const tooltipContent = (
    <div className="max-w-md">
      <div className="text-sm font-semibold text-gray-900 mb-2">
        Segment Filters
      </div>
      <div className="space-y-2">
        {segmentFilters.map((group, groupIndex) => (
          <div key={`group-${groupIndex}`} className="space-y-1">
            {group.ors && group.ors.length > 0 && (
              <div className="flex flex-wrap items-center gap-1">
                {group.ors.map((condition, conditionIndex) => (
                  <React.Fragment
                    key={`condition-${groupIndex}-${conditionIndex}`}
                  >
                    <Badge className="text-xs">
                      {getFilterIcon(condition.type)}{" "}
                      {getFilterLabel(condition)}
                    </Badge>
                    {conditionIndex < group.ors.length - 1 && (
                      <span className="text-xs text-gray-500">or</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
            {groupIndex < segmentFilters.length - 1 && (
              <div className="text-xs text-gray-500 text-center">and</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  const isBottom = placement === "bottom";

  return (
    <div className="relative group">
      {children}
      <div
        className={`absolute left-1/2 transform -translate-x-1/2 px-3 py-2 bg-white text-gray-900 text-sm rounded-lg shadow-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50 ${
          isBottom ? "top-full mt-2" : "bottom-full mb-2"
        }`}
      >
        {tooltipContent}
        <div
          className={`absolute left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-transparent ${
            isBottom
              ? "bottom-full border-b-4 border-b-white"
              : "top-full border-t-4 border-t-white"
          }`}
        ></div>
      </div>
    </div>
  );
}
